var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInformationIconInCircleGrey = function SvgInformationIconInCircleGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#fff",
    stroke: "#848484"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    d: "M10.75 8.444C9.792 8.444 9 7.71 9 6.73 9 5.734 9.792 5 10.75 5c.976 0 1.75.734 1.75 1.731 0 .979-.774 1.713-1.75 1.713m1.474 1.43V16H9.239V9.874z"
  })));
};
export { SvgInformationIconInCircleGrey as ReactComponent };
export default __webpack_public_path__ + "images/information-icon-in-circle-grey.svg";